import createAction from '../services/create-action';
import sanitizeContent from '../services/sanitize-content';

export const CREATE_COMMENT_REQUEST = 'comment/CREATE_REQUEST';
export const CREATE_COMMENT_SUCCESS = 'comment/CREATE_SUCCESS';
export const CREATE_COMMENT_FAILURE = 'comment/CREATE_FAILURE';

export const createCommentRequest = createAction(CREATE_COMMENT_REQUEST);
export const createCommentSuccess = createAction(CREATE_COMMENT_SUCCESS);
export const createCommentFailure = createAction(CREATE_COMMENT_FAILURE);

export function createComment(postId, comment = {}) {
  return (dispatch, getState, { request }) => {
    dispatch(createCommentRequest());

    const promise = request.post(`/_api/posts/${postId}/comments`, sanitizeContent(comment));

    return promise
      .then(data => dispatch(createCommentSuccess(data)))
      .catch(() => dispatch(createCommentFailure()))
      .then(() => promise);
  };
}



// WEBPACK FOOTER //
// ./app/actions/create-comment.js